import { Routes } from '@angular/router';
import { IndexComponent } from './routes/index/index.component';
import { AccountComponent } from './routes/account/account.component';
import { RequestComponent } from './routes/account/request/request.component';
import { FuelComponent } from './routes/account/request/fuel/fuel.component';
import { RecipientComponent } from './routes/account/request/recipient/recipient.component';
import { LocationComponent } from './routes/account/request/location/location.component';
import { ResultsComponent } from './routes/account/request/results/results.component';
import { PaymentComponent } from './routes/account/request/payment/payment.component';
import { OrdersComponent } from './routes/account/orders/orders.component';
import { OrdersHistoryComponent } from './routes/account/orders/orders-history/orders-history.component';
import { OrderDetailsComponent } from './routes/account/orders/order-details/order-details.component';
import { OrderReceiptComponent } from './routes/account/orders/order-receipt/order-receipt.component';
import { ProfileComponent } from './routes/account/profile/profile.component';
import { PaymentPageComponent } from './routes/account/payment-page/payment-page.component';
import { PromosComponent } from './routes/account/promos/promos.component';
import { PageNotFoundComponent } from './routes/page-not-found/page-not-found.component';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { SignupComponent } from './routes/account/request/signup/signup.component';
import { PromoClaimComponent } from './routes/promo-claim/promo-claim.component';
var ɵ0 = { id: 'promo' }, ɵ1 = { id: 'account' }, ɵ2 = { translate: 'ROUTES.ALLORDERS' }, ɵ3 = { translate: 'ROUTES.ORDERDETAILS' }, ɵ4 = { translate: 'ROUTES.ORDERRECEIPT' }, ɵ5 = { translate: 'ROUTES.ORDERDETAILS' };
var routes = [
    {
        path: '', component: IndexComponent
    },
    {
        path: 'promo', component: PromoClaimComponent, data: ɵ0
    },
    {
        path: 'account', component: AccountComponent, data: ɵ1,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'request',
            },
            {
                path: 'request', component: RequestComponent,
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'fuel'
                    },
                    {
                        path: 'fuel', component: FuelComponent
                    },
                    {
                        path: 'recipient', component: RecipientComponent
                    },
                    {
                        path: 'location', component: LocationComponent
                    },
                    {
                        path: 'results', component: ResultsComponent
                    },
                    {
                        path: 'payment', component: PaymentComponent
                    },
                    {
                        path: 'sign-up', component: SignupComponent
                    }
                ]
            },
            {
                path: 'orders', component: OrdersComponent, canActivate: [AuthGuard],
                children: [
                    {
                        path: '', component: OrdersHistoryComponent, data: ɵ2
                    },
                    {
                        path: 'details/:orderId', component: OrderDetailsComponent, data: ɵ3
                    },
                    {
                        path: 'receipt/:id', component: OrderReceiptComponent, data: ɵ4
                    },
                    {
                        path: 'info/:id', component: OrderReceiptComponent, data: ɵ5
                    }
                ]
            },
            {
                path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]
            },
            {
                path: 'promos', component: PromosComponent, canActivate: [AuthGuard]
            },
            {
                path: 'payment', component: PaymentPageComponent, canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: '404', component: PageNotFoundComponent,
    },
    {
        path: '**', redirectTo: '/404',
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
